export const vendorManagementAPIRoutes = {
  baseUrl: process.env.REACT_APP_TOURISM_CLASSIFIED_API_URL,
  vendor: {
    endpoints: 'vendor',
    findById: 'findById',
    getVendorDetailByUserId: 'getVendorDetailByUserId',
    updateVendorDetail: 'update',
    getAllVendorDetailBySearchCriteria: 'getVendorDetailBySearchCriteria',
    getVendorDocumentDetail: 'getVendorDocumentDetail',
    rejectVendorDetail: 'rejectVendorDetail',
    approveVendorDetail: 'approveVendorDetail',
    deleteVendorDetal: 'delete',
    findByDomainName: 'findByVendorDomainName',
    vendorHistory: 'history/getVendorDetailBySearchCriteria',
    checkVendorSubscription: 'checkVendorSubscription',
    addVendorSubscription: 'addVendorSubscription'
  }
};
